import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import swal from "sweetalert";

import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

//Icomoon
import "@/assets/css/icomoon.css";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDo382iYc6rfETFyrdSO5_KBRrEON9D7Yg",
    libraries: "places,drawing", // necessary for places input
  },
});

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;
Vue.prototype.$swal = swal;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
